export default __webpack_public_path__ + "static/media/image_12.62986cb7.jpg";